import React, { useRef } from "react"
import { useOnClickOutside } from "../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import { isEmpty } from "lodash";

const ChangeLogPlannedRevenueModal = () => {
    const ref = useRef();
    const dispatch = useDispatch();
    const initData = useSelector(state => state.cassa.plannedRevenue);

    const onClose = () => dispatch(setActiveModalAction({ field: 'changeLogPlannedRevenue', value: null }));
    
    useOnClickOutside(ref, onClose);

    const renderChangeLog = (log) => {
        if (isEmpty(log)) return;
        return(
            <div style={{ position: 'relative' }}>
                {Object.entries(log).sort(([aKey, a], [bKey, b]) => moment(bKey, 'DD.MM.YYYY') - moment(aKey, 'DD.MM.YYYY')).map(([key, changes]) => {
                    return(
                        <div className='dropdown_row_changeLog' style={{ whiteSpace: 'wrap' }}>
                            <div style={{ color: '#000', fontWeight: 600 }}>{`Дата изменения: ${key}`}</div>
                            {
                                changes.map((change) => {
                                    const { prevValue, newValue, field, user, dateTime } = change;

                                    const renderText = () => {
                                        if (prevValue) return `Плановая выручка для даты ${field} изменена с ${prevValue} на ${newValue || 0}`;
                                        return `Плановая выручка для даты ${field} добавлено значение ${newValue}`;
                                    }

                                    return (
                                        <div className="dropdown_row_changeLog">
                                            <div style={{ color: '#000'}}>{`Время изменения: ${moment(dateTime, 'DD.MM.YYYY HH:mm:ss').format('HH:mm:ss')}`}</div>
                                            <div style={{ color: '#000'}}>{`Автор изменения: ${user || '-'}`}</div>
                                            <div style={{ color: '#000'}}>{renderText()}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    );
                })}
            </div>
        )
    }

    return(
        <form>
            <div  className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={ window.innerWidth > 1024 ? {} : { maxHeight: 'calc(100vh - 200px)' }}>
                        <div className="modal-header">
                            <h5 className="modal-title"> История изменений </h5>
                            <button onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ paddingLeft: 0, paddingRight: 0 }}>
                            {renderChangeLog(initData.changeLog)}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default withRouter(ChangeLogPlannedRevenueModal);